/* ============
 * The initial state of the careplan module.
 * ============
 */

export default {
  loading: false,
  followUp: {},
  followUpList: [],
  followUpSymptoms: [],
  resolvedNotes: [],
  totalCount: 0,
  errorMessage: '',
  resolvedAlertId: '',
  isResolutionLoading: false,
};
